import React from 'react';
import cn from 'classnames';

import type { AnalyticAttrs } from 'services/analytics';

import './segmentTab.scss';

interface Props {
    text: string;
    title?: string;
    analyticAttrs?: AnalyticAttrs;
    isActive?: boolean;
    isDisabled?: boolean;
    onClick?: VoidFn;
}

const SegmentTab: React.FC<Props> = ({
    isActive,
    text,
    title,
    onClick,
    analyticAttrs,
    isDisabled,
}) => {
    return (
        <div
            styleName={cn('container', {
                'is-active': isActive,
                'is-disabled': isDisabled,
            })}
            title={title}
            onClick={isDisabled ? undefined : onClick}
            {...analyticAttrs}
        >
            <span>{text}</span>
        </div>
    );
};

export default SegmentTab;
